import { CommunityTab } from "@/components/community/CommunityTab";
import { NotesProvider, HeaderMessagesButton } from "@/components/notes/NotesHub";

// Phase 4 (2026-02): the NJM-staff-facing entry point to the SAME shared Community feed the
// Freelancer Portal's own tab renders (both mount <CommunityTab/> — one component, one feed,
// two doors in). Route-gated by AppShell's staffOnly wrapper; the module itself is still
// scope-gated server-side (community.read/write/moderate/announce), same as every other page.
// CommunityTab.jsx owns its own "The Floor" heading/sprocket treatment, so this page shell
// stays a plain AppShell-consistent container — no duplicate heading.
//
// Collaboration UX Wave 1 (2026-09): `NotesProvider` was only ever mounted inside
// FreelancerPortal.jsx's own tree (the freelancer-facing Floor tab also renders this same
// `CommunityTab`) — this route rendered the identical `CollaborationDetailModal`/
// `CollaborationApplicationsPanel` components but with no Notes context available at all, so
// `useNotes()` returned `{}`, `openSendNote` was `undefined`, and every "Message creator"/
// "Send note →" button on this page silently never rendered. Mounted locally here (not lifted
// into App.js) to keep the diff isolated to this one route.
export default function Community() {
  return (
    <NotesProvider>
      <div className="mx-auto max-w-3xl px-4 sm:px-8 py-6 sm:py-10" data-testid="community-page">
        <div className="flex justify-end mb-2"><div className="bg-ink rounded-full inline-flex" data-testid="community-header-messages-wrap"><HeaderMessagesButton /></div></div>
        <CommunityTab />
      </div>
    </NotesProvider>
  );
}
